import {createContext, useContext} from 'react';
import type {BreakpointSize} from './breakpoints';
import {defaultBreakpoint} from './breakpoints';

interface IViewportContext {
  breakpoint: BreakpointSize;
  width: number;
  height: number;
  showMobileView: boolean;
}

export const ViewportContext = createContext<IViewportContext>({
  breakpoint: defaultBreakpoint,
  width: 0,
  height: 0,
  showMobileView: false,
});

export const useViewport = () => useContext(ViewportContext);
